import type { Maybe } from "~/types";

export interface BooleanProps {
  value: Maybe<boolean>;
}

export function Boolean({ value }: BooleanProps) {
  return value == null ? "-" : value ? "True" : "False";
}
